import { isFeatureEnabled } from '@lumapps/features';

import { LUMAPPS_APPLICATION_IDENTITY_FEATURE_TOKEN } from '../constants';

export const isLumappsApplicationIdentityEnabled = isFeatureEnabled(LUMAPPS_APPLICATION_IDENTITY_FEATURE_TOKEN);
